import * as colors from "@mui/material/colors";

const themeLightColors = {
  // TODO: should use deep-merge utility when extending MUI's default colors (and not shallow like below)
  ...colors,
  common: {
    black: "#000",
    white: "#FFF",
  },
  blue: {
    100: "oklch(0.2 0.1 255)",
    400: "oklch(0.3 0.12 255)",
    500: "oklch(0.4 0.12 255)",
    600: "oklch(0.6 0.12 255)",
    700: "oklch(0.85 0.1 255)",
    800: "oklch(0.97 0.045 255)",
    900: "oklch(0.98 0.001 200)",
  },
  blueAccent: {
    100: "#151632",
    200: "#2a2d64",
    300: "#3e4396",
    400: "#535ac8",
    500: "#6870fa",
    600: "#868dfb",
    700: "#a4a9fc",
    800: "#c3c6fd",
    900: "#e1e2fe",
  },
  defy: {
    100: "oklch(0.2 0.05 195)",
    200: "oklch(0.35 0.06 195)",
    300: "oklch(0.53 0.09 195)",
    400: "oklch(0.684 0.11 197)",
    500: "oklch(0.8 0.13 184)",
    700: "oklch(0.85 0.0933 196)",
    800: "oklch(0.9 0.04 175)",
    900: "oklch(0.97 0.02 175)",
  },
  green: {
    100: "oklch(0.4 0.1 160)",
    200: "oklch(0.5 0.12  150)",
    300: "oklch(0.55 0.12  150)",
    400: "oklch(0.6 0.12  150)",
    500: "#4CAF50",
    600: "oklch(0.7 0.12  150)",
    700: "#81C784",
    800: "#A5D6A7",
    900: "#E8F5E9",
  },
  grey: {
    100: "#141414",
    200: "#292929",
    300: "#3d3d3d",
    400: "#525252",
    500: "#666666",
    600: "#858585",
    700: "#a3a3a3",
    800: "#c2c2c2",
    900: "#e0e0e0",
    950: "#F6F6F6",
    999: "#fcfcfc",
  },
  orange: {
    100: "oklch(0.5 0.22 68)",
    300: "oklch(0.55 0.20 52)",
    400: "oklch(0.6 0.18 48)",
    500: "oklch(0.65 0.16 48)",
    600: "oklch(0.7 0.15 48)",
    800: "oklch(0.8 0.12 48)",
    900: "oklch(0.98 0.08 48)",
    950: "oklch(1 0.07 48)",
  },

  pink: {
    ...colors.pink,
    400: "#AD1457",
    800: "#F8BBD0",
    900: "#FCE4EC",
  },

  primary: {
    100: "#040509",
    200: "#080b12",
    300: "#0c101b",
    400: "#f2f0f0", // manually changed
    500: "#141b2d",
    600: "#1F2A40",
    700: "#727681",
    800: "#a1a4ab",
    900: "#d0d1d5",
  },

  red: {
    200: "oklch(0.8 0.2 25)",
    400: "oklch(0.7 0.2 25)",
    500: "#D32F2F",
    600: "#EF5350",
    800: "#fdd7d7",
    900: "#fdeded",
  },
  yellow: {
    400: "#FACC15",
  },
};

type LightThemeColorsType = typeof themeLightColors;

export type ColorType = {
  [colorName in keyof LightThemeColorsType]: {
    [colorVariant in keyof LightThemeColorsType[colorName]]: string;
  };
};
export default themeLightColors;
